import { appPowerPoint } from 'owa-locstrings/lib/strings/apppowerpoint.locstring.json';
import { appExcel } from 'owa-locstrings/lib/strings/appexcel.locstring.json';
import { appWord } from 'owa-locstrings/lib/strings/appword.locstring.json';
import loc from 'owa-localize';
import { getOfficeOnlineAppFromExtension, OfficeOnlineApp } from 'owa-file';

export interface OfficeOnlineAppInfo {
    app: OfficeOnlineApp;
    displayName: string;
    className: string;
    appName: string;
}

const styles = require('../components/SxSView.scss');

export function fileNameToOfficeOnlineApp(fileName: string): OfficeOnlineAppInfo {
    const extension = fileName && fileName.substring(fileName.lastIndexOf('.'));
    return fileExtensionToOfficeOnlineApp(extension);
}

export default function fileExtensionToOfficeOnlineApp(extension: string): OfficeOnlineAppInfo {
    const officeOnlineApp = getOfficeOnlineAppFromExtension(extension);
    switch (officeOnlineApp) {
        case OfficeOnlineApp.Word:
            return {
                app: OfficeOnlineApp.Word,
                displayName: loc(appWord),
                className: styles.word,
                appName: 'Word',
            };
        case OfficeOnlineApp.Excel:
            return {
                app: OfficeOnlineApp.Excel,
                displayName: loc(appExcel),
                className: styles.excel,
                appName: 'Excel',
            };
        case OfficeOnlineApp.PowerPoint:
            return {
                app: OfficeOnlineApp.PowerPoint,
                displayName: loc(appPowerPoint),
                className: styles.powerpoint,
                appName: 'PowerPoint',
            };
        default:
            return null;
    }
}
